module.exports = __webpack_public_path__ + "img/choose-up-11_1.f6731620.png";